// 
export const START_LOADING = 'START_LOADING';
export const SET_USER_DETAIL = 'SET_USER_DETAIL';
export const SET_USER_TOKEN = 'SET_USER_TOKEN';

export const CURRENT_LOCATION = 'CURRENT_LOCATION';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export const UPDATE_USER_DETAILS = 'UPDATE_USER_DETAILS';
export const LOGOUT = 'LOGOUT';

// 
export const ADD_SERVICE_FORM_DATA = 'ADD_SERVICE_FORM_DATA';
export const APP_VERSION = 'APP_VERSION';